import { render, staticRenderFns } from "./orderCD.vue?vue&type=template&id=3d619166&scoped=true"
import script from "./orderCD.vue?vue&type=script&lang=js"
export * from "./orderCD.vue?vue&type=script&lang=js"
import style0 from "./orderCD.vue?vue&type=style&index=0&id=3d619166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d619166",
  null
  
)

export default component.exports